import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable, from, of, throwError } from 'rxjs';
import { map, mergeMap, shareReplay, tap, toArray } from 'rxjs/operators';



const USER_DATA = {
  "data": [
    {
      "partner_id" : "accounts/10596",
      "partner_name" : "tomwelsh",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer"
    },
    {
      "partner_id" : "accounts/10596",
      "partner_name" : "tomwelsh",
      "customer_id" : "11172",
      "customer_email" : "agaspulsarrs1@gmail.com",
      "organisation_name" : "Vista Customer",
    }
  ],
  "total": 2,
  "validated": 2
}



const PARTNER_AUDIT_DATA = {
  data: {
    "Partner_Details": {
      "companyName": "Dodi Solutions Private Limitedk",
      "contactName": "AvneetDhodij",
      "contactEmail": "cmtestuser090502@yopmail.com",
      "phoneNumber": "9871737647",
      "addressStreet": "291-ADG-2Vikaspuri",
      "addressSuite": "NewDelhi",
      "addressCity": "NewDelhi",
      "addressState": "Delhi",
      "addressZip": "110018",
      "addressCountry": "IN",
      "Remarks": null
    },
    "Features_Enabled": {
      "DASHBOARD": true,
      "PRODUCTS": true,
      "TEST_DRIVES": true,
      "BILLING": true,
      "PARTNERS": true,
      "CUSTOMERS": true,
      "SUPPORT": true,
      "STORE": true,
      "catalogEnabled": true,
      "v3CatalogEnabled": true,
      "productsSharingEnabled": true,
      "showPartnerV3CatalogOptions": true,
      "Remarks": null
    },
    "Provider_Details": [
      {
        "Id": 2,
        "Name": "Google Cloud Platform",
        "Remarks": null
      },
      {
        "Id": 28,
        "Name": "Microsoft Modern Workplace",
        "Remarks": null
      }
    ],
    "Pricebook_Details": [
      {
        "Provider": "Google Cloud Platform",
        "Pricebook_Id": 0,
        "Currency": "USD",
        "Invoice_Currency": "USD",
        "Remarks": null
      },
      {
        "Provider": "Microsoft Modern Workplace",
        "Pricebook_Id": 0,
        "Currency": "USD",
        "Invoice_Currency": "USD",
        "Remarks": null
      },
      {
        "Provider": "Microsoft Modern Workplace",
        "Pricebook_Id": 0,
        "Currency": "INR",
        "Invoice_Currency": "INR",
        "Remarks": null
      }
    ],
    "ISV_Details": {
      "ISV_Name": "Apptium Demo ISV",
      "ISV_email": "amttestuser@apptium.com",
      "Remarks": null
    },
    "Program_Details": [
      {
          "Program_Id": "39",
          "approval_status": "Approved",
          "ProgramRemarks": ""
      },
      {
          "Program_Id": "32",
          "approval_status": "Not Approved",
          "ProgramRemarks": "Request Id not fetched"
      }
    ],
    "CustomField_Details": [
        {
            "CustomField": "SAP_ID",
            "Value": "SAP_ID",
            "Status": "Mapped",
            "CustomFieldRemarks": null
        },
        {
            "CustomField": "territory",
            "Value": "territory",
            "Status": "Mapped",
            "CustomFieldRemarks": null
        }
    ]
  }
}

const CUSTOMER_DEFAULT_AUDIT_DATA = {
  data: {
    "Customer_Fetch": {
      "Reseller_Id": "accounts/10596",
      "Reseller_Name": "tomwelsh",
      "Customer_Name": "Demo Customer",
      "Customer_Email": "cmtestuser090502@yopmail.com",
      "Remarks": null
    },
    "User_Validation": {
      "Reseller_Id": "accounts/10596",
      "Reseller_Name": "tomwelsh",
      "Customer_Name": "Demo Customer",
      "Customer_Email": "cmtestuser090502@yopmail.com",
      "User_Exists": "Yes",
      "Remarks": null
    },
    "User_Creation": {
      "Reseller_Id": "accounts/10596",
      "Reseller_Name": "tomwelsh",
      "Customer_Name": "Demo Customer",
      "Customer_Email": "cmtestuser090502@yopmail.com",
      "User_Name": "vinitha",
      "User_Email" : "vinitha@apptium.com",
      "Status" : "Active",
      "User_Created": "Yes",
      "Remarks": null,
    },
  }
}

const CUSTOMER_CUSTOM_AUDIT_DATA = {
  data: {
    "Data_Validation": [{
      "Reseller_Id": "accounts/10596",
      "Reseller_Name": "tomwelsh",
      "Customer_Name": "Demo Customer",
      "Customer_Email": "cmtestuser090502@yopmail.com",
      "User_Name": "vinitha",
      "User_Email" : "vinitha@apptium.com",
      "Status" : "Active",
      "Valid/Invalid": "Valid",
      "Remarks": null
    }],
    "Customer_Validation": [{
      "Reseller_Id": "accounts/10596",
      "Reseller_Name": "tomwelsh",
      "Customer_Name": "Demo Customer",
      "Customer_Email": "cmtestuser090502@yopmail.com",
      "User_Name": "vinitha",
      "User_Email" : "vinitha@apptium.com",
      "Status" : "Active",
      "Valid/Invalid": "Valid",
      "Remarks": null
    }],
    "User_Creation": [{
      "Reseller_Id": "accounts/10596",
      "Reseller_Name": "tomwelsh",
      "Customer_Name": "Demo Customer",
      "Customer_Email": "cmtestuser090502@yopmail.com",
      "User_Name": "vinitha",
      "User_Email" : "vinitha@apptium.com",
      "Status" : "Active",
      "Created": "Yes",
      "Remarks": null
    }],
  }
}


const AUDITS_DATA = {
  "data": [
    {
      'partner_id': 'accounts/8416',
      'nickname': 'cmtestuser1805',
      'companyName': 'Demo Solutions Private Limitedk',
      "isvName": "Apptium Demo ISV",
      "partner_exists": true,
      'Remarks': 'Completed',
    },
    {
      'partner_id': 'accounts/8417',
      'nickname': 'cmtestuser1806',
      'companyName': 'Demo Solutions Private Limitedk',
      "isvName": "Apptium Demo ISV",
      "partner_exists": true,
      'Remarks': 'Partially completed'
    },
    {
      'partner_id': 'accounts/8418',
      'nickname': 'cmtestuser1807',
      'companyName': 'Demo Solutions Private Limitedk',
      "isvName": "Apptium Demo ISV",
      "partner_exists": false,
      'Remarks': 'Partially completed'
    },
    {
      'partner_id': 'accounts/8414',
      'nickname': 'cmtestuser0011121',
      'companyName': 'Demo Solutions Private Limitedk',
      "isvName": "Apptium Demo ISV",
      "partner_exists": false,
      'Remarks': 'Completed'
    },
    {
      'partner_id': 'accounts/8415',
      'nickname': 'cmtestuser0012211',
      'companyName': 'Demo Solutions Private Limitedk',
      "isvName": "Apptium Demo ISV",
      "partner_exists": true,
      'Remarks': 'Failed'
    }
  ],
  "status": 200,
  'filename': 'partner_create.xlsx',
}

const AUDITS_CUSTOMER_DATA = {
  "data": [
    {
      "id" : 185,
      "partner_id" : "accounts/10596",
      "partner_name" : "tomwelsh",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer",
      "partner_exists": true,
      'Remarks': 'Completed',
    },
    {
      "id" : 186,
      "partner_id" : "accounts/10596",
      "partner_name" : "tomwelsh",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer",
      "partner_exists": true,
      'Remarks': 'Partially completed'
    },
    {
      "id" : 187,
      "partner_id" : "accounts/10597",
      "partner_name" : "InfoCity",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer",
      "partner_exists": true,
      'Remarks': 'Partially completed'
    },
    {
      "id" : 187,
      "partner_id" : "accounts/10598",
      "partner_name" : "No WINSTER",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer",
      "partner_exists": true,
      'Remarks': 'Partially completed'
    },
    {
      "id" : 187,
      "partner_id" : "accounts/10598",
      "partner_name" : "No WINSTER",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer",
      "partner_exists": true,
      'Remarks': 'Partially completed'
    },
    {
      "id" : 187,
      "partner_id" : "accounts/10599",
      "partner_name" : "No WINSTER",
      "customer_id" : "11165",
      "customer_email" : "agaspulsarrs@gmail.com",
      "organisation_name" : "Demo Customer",
      "partner_exists": true,
      'Remarks': 'Partially completed'
    }
  ],
  "status": 200,
  'mode': 'default',
  'filename': 'system'
}

const USERS_DATA = {
  "data": [
    {
      "userName": "Stephen",
      "userEmail": "steve@apptium.com",
      "status": "completed"
    }
  ],
  "status": 200
}

const TRACK_DATA = {
  35: [{
      "state_id": 1,
      "state_name": "Data Validation",
      "result": "Completed"
    },
    {
      "state_id": 2,
      "state_name": "Partner Creation",
      "result": "Completed"
    }, {
      "state_id": 3,
      "state_name": "Provider Mapping",
      "result": "Completed"
    }, {
      "state_id": 4,
      "state_name": "ISV Mapping",
      "result": "Completed"
    }, {
      "state_id": 5,
      "state_name": "Feature Enablement",
      "result": "Completed"
    },
    {
      "state_id": 6,
      "state_name": "Pricebook Mapping",
      "result": "Completed"
    }, {
      "state_id": 7,
      "state_name": "Program Mapping",
      "result": "Completed"
    }, , {
      "state_id": 8,
      "state_name": "Custom Field Mapping",
      "result": "Completed"
    }],
    34: [{
      "state_id": 1,
      "state_name": "Data Validation",
      "result": "Completed"
    },
    {
      "state_id": 2,
      "state_name": "Partner Creation",
      "result": "Completed"
    }, {
      "state_id": 3,
      "state_name": "Provider Mapping",
      "result": "Partially Completed"
    }, {
      "state_id": 4,
      "state_name": "ISV Mapping",
      "result": "Skipped"
    }, {
      "state_id": 5,
      "state_name": "Feature Enablement",
      "result": "Failure"
    },
    {
      "state_id": 6,
      "state_name": "Pricebook Mapping",
      "result": "Skipped"
    }, {
      "state_id": 7,
      "state_name": "Program Mapping",
      "result": "Skipped"
    }, {
      "state_id": 8,
      "state_name": "Custom Field Mapping",
      "result": "Completed"
    }],
    51: [{
      "state_id": 1,
      "state_name": "Customer Fetch",
      "result": "Completed"
    },
    {
      "state_id": 2,
      "state_name": "User Validation",
      "result": "Skipped"
    }, {
      "state_id": 3,
      "state_name": "User Account Creation",
      "result": "Failure"
    }],
    52: [{
      "state_id": 1,
      "state_name": "Data Validation",
      "result": "Completed"
    },
    {
      "state_id": 2,
      "state_name": "Customer Validation",
      "result": "Partially Completed"
    }, {
      "state_id": 3,
      "state_name": "User Account Creation",
      "result": "Completed"
    }]
}

const PARTNER_UPLOAD_STEPS  = {"data":[
  {"state_id":1,"name":"Data Validation"},
  {"state_id":2,"name":"Partner Creation"},
  {"state_id":3,"name":"Provider Mapping"},
  {"state_id":4,"name":"ISV Mapping"},
  {"state_id":5,"name":"Pricebook Mapping"},
  {"state_id":6,"name":"Program Mapping"}, 
  {"state_id":7,"name": "Custom Field Mapping"},
  {"state_id":8,"name":"Feature Enablement"}],"status":200}

export interface TrackStatus {
  state_name: string;
  state_status: string;
}

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService {

  trackSubject = new BehaviorSubject<TrackStatus>({ "state_name": "", "state_status": "" });
  trackStatus$ = this.trackSubject.asObservable();

  disableSectionsSubject = new BehaviorSubject<boolean>(false);
  disableSections$ = this.disableSectionsSubject.asObservable();

  showPartnerUploadStatusDialogSubject = new BehaviorSubject<any>({"partner_upload_status": ""})
  showPartnerUploadStatusDialog$ = this.showPartnerUploadStatusDialogSubject.asObservable();

  showDisacardConsentDialogSubject = new BehaviorSubject<boolean>(false)
  showDisacardConsentDialog$ = this.showDisacardConsentDialogSubject.asObservable();

  updateDisacardConsentDialog(res: boolean) {
    this.showDisacardConsentDialogSubject.next(res);
  }

  currentUrl: string = undefined;
  previousUrl: string = undefined;

  constructor(private readonly http: HttpClient, private readonly router: Router) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
  }

  getPreviousUrl() {
    return this.previousUrl;
  }

  updateDisableSection(result: boolean) {
    this.disableSectionsSubject.next(result);
  }

  updatePartnerUploadStatusDialog(res) {
    this.showPartnerUploadStatusDialogSubject.next({partner_upload_status: res});
  }

  getPartnerUploadSteps(): Observable<any> {
    let request_url = 'api/master/get-migration-states';
    return this.http.get(
      request_url
    );
  }

  partnerUpload(data: any): Observable<any> {
    let request_url = 'api/master/partner-onboard';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: data.fileName,
      fileData: data.fileData
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  startPartnerMigration(data: any, state_id, state_name) {
    let request_url = 'api/master/partner-migration';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: data.fileName,
      fileData: data.fileData,
      file_id: data.id,
      state_id: state_id,
      state_name: state_name
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  getPreviewDataType() {
    let request_url = `api/master/get-columns`;
    return this.http.get(
      request_url
    )
  }

  getPartnerMigrationStatus(file_id: number, step_id: number,retry_count: number) {
    let request_url = `api/master/get-partner-migration/status/${file_id}/${step_id}/${retry_count}`;
    return this.http.get(
      request_url   
    );
  }

  retryDataValidation(file_id,step_id,preview_data): Observable<any> {
    let request_url = `api/master/retry-data-validation`;
    let request_body = {
      file_id: file_id,
      step_id: step_id,
      preview_data: preview_data
    }
    return this.http.post(
      request_url,
      request_body
    )
}

  initDataValidate(file_id: number, doValid: boolean){
    let request_url = `api/master/validate/migration`;
    let request_body = {
      file_id: file_id,
      do_validation: doValid,
      useremail: JSON.parse(sessionStorage.getItem('userInfo')).email
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  initUserDataValidate(file_id: number, doValid: boolean){
    let request_url = `api/master/validate/usermigration`;
    let request_body = {
      file_id: file_id,
      do_validation: doValid,
      useremail: JSON.parse(sessionStorage.getItem('userInfo')).email
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  consolidateReportDownload(file_id: number, type: string, isErrorReport: number) {
    let partner_url = `api/master/get-consolidated/report/${file_id}/?has_error=${isErrorReport}`;
    let customer_url = `api/master/get-user-consolidated/report/${file_id}/?has_error=${isErrorReport}`;
    let request_url = type === 'partner' ? partner_url : customer_url;
    return this.http.get(
      request_url
    )
  }

  getCustomerUploadSteps(mode: string): Observable<any> {
    let request_url = `api/master/get-user-states/`;
    return this.http.get(
      request_url
    );
  }

  customerUpload(data: any, mode: string) {
    let request_url = 'api/master/customer-onboard';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: data.fileName || '',
      fileData: data.fileData || '',
      mode: mode
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  startCustomerMigration(data: any, mode: string, state_id: number, state_name: string) {
    let request_url = 'api/master/create-user';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: data.fileName,
      fileData: data.fileData,
      file_id: data.id,
      mode: mode,
      state: state_name.replace(/ /g,"_")
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  getCustomerMigrationStatus(file_id: number, mode: string, state: string) {
    let request_url = `api/master/get-customer-migration/status?state=${state.replace(/ /g,"_")}&mode=${mode}&file_id=${file_id}`;
     return this.http.get(
      request_url   
    );
  }

  getHistoryLists(data): Observable<any> {
    let request_url = `api/master/${data.type}-transaction/audit/?file_id=0&from_date=${data.from_date}&to_date=${data.to_date}`;
    return this.http.get(
      request_url
    );
  }

  getPartnerListForValidate(fileID: number, deviations: number) {
    let request_url = `api/master/get-valid-partners/${fileID}/?deviation=${deviations}`;
    return this.http.get(
      request_url
    );
  }

  getUserListForValidate(fileID: number, deviations: number) {

    let request_url = `api/master/get-valid-customers/${fileID}/?deviation=${deviations}`;
    return this.http.get(
      request_url
    );
  }


  getValidationData(id: string, file_id: number, type: string): Observable<any> {
    let request_url = `api/master/get-${type}-details/validate?${type}_id=${id}&file_id=${file_id}`;
    return this.http.get(
      request_url
    );
  }

  getAuditData(id: string, type: string): Observable<any> {
    let request_url = `api/master/${type}-transaction/audit/?file_id=${id}`;
    return this.http.get(
      request_url
    );
  }

  getCustomerData(id: string, typeId: string, type: string, mode: string): Observable<any> {
    let request_url = `api/master/get-${type}-consolidation/?file_id=${id}&${type}_id=${typeId}`;
    return this.http.get(
      request_url
    );
  }

  getUserData(customer_id: string): Observable<any> {
    let request_url = `api/master/get-users/${customer_id}/`;
    return this.http.get(
      request_url
    );
  }

  getTrackProcess(fileId: number, type: string, mode: string) {
    let partner_url = `api/master/track-migration-state/${fileId}/`;
    let user_url = `api/master/track-user-state/${fileId}/${mode}/`;
    let request_url = type === 'partner' ? partner_url : user_url;
    this.http.get(
      request_url
    ).subscribe((res: any) => {
      let resultData = res.data;
      this.trackSubject.next(resultData as any)
    });
  }

  submitConfigFile(fileName: string,fileData: any): Observable<any> {
    let request_url = `api/master/manage/configuration`;
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: fileName,
      fileData: fileData
    }
    return this.http.post(
      request_url,
      request_body
    );
  } 

  getISV(name): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-all-accounts?name=${name}`;
    return this.http.get(request_url);
  }

  getCustomersList(search, transactionID): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-customers?org_name=${search}&trans_id=${transactionID}`;
    return this.http.get(request_url);
  }

  getAccountsList(search, transactionID, customersList): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-cloudAccounts`;
    let payload = {
      trans_id: transactionID,
      customers: customersList,
      cloudAccounts: search
    }
    return this.http.put(request_url, payload);
  }

  getResellers(isvDetails,search): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-partners?id=${isvDetails.id}&name=${isvDetails.name}&filter=${search}`;
    return this.http.get(request_url);
  }

  getCloudProviders(resellerDetailsObj): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-providers`;
    let request_body = {
      partners: resellerDetailsObj
    }
    return this.http.post(request_url, request_body);
  }

  getCurrencyList(resellerID, providerID): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-currencies?partner_id=${resellerID}&provider_id=${providerID}`
    return this.http.get(
      request_url
    );
  }

  getPricebookList(resellerID, providerID, currency): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-pricebooks?partner_id=${resellerID}&provider_id=${providerID}&currency=${currency}`
    return this.http.get(
      request_url
    );
  }

  getAllPricebookList(partner_id,provider_id): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-pricebooks?partner_id=${partner_id}&provider_id=${provider_id}`
    return this.http.get(
      request_url
    );
  }

  getAccountPricebookList(account_id, providerID): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-pricebooks?partner_id=${account_id}&provider_id=${providerID}`
    return this.http.get(
      request_url
    );
  }

  getCustomerSubscription(formData): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/get-customer-subscriptions`;
    let request_body = {
      account_id: formData.accountNameCtrl.id,
      account_name: formData.accountNameCtrl.name,
      provider_id: formData.cloudProviderCtrl.id,
      provider_name: formData.cloudProviderCtrl.name,
      short_name: formData.cloudProviderCtrl.shortName,
      customers: [],
      cloud_accounts: []
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  closeTransaction(id: number) {
    let request_url = `api/pricebook/bulkupdate/customer-subscription/info?trans_id=${id}`;
    return this.http.delete(request_url);
  }

  getUpdateHistory(data): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/activity-monitor?module=${data.module}&from_date=${data.from_date}&to_date=${data.to_date}`;
    return this.http.get(request_url);
  }

  executePriceBookBulkUpdate(chunk: any[]): Observable<any> {
    let request_url = '';
    return of({})
  }

  sendPriceBookBulkUploadInChunks(payloadArray: any[], batchSize: number): Observable<any[]>{
    const payloadChunks = [];
    for (let i = 0; i < payloadArray.length; i += batchSize) {
      payloadChunks.push(payloadArray.slice(i, i + batchSize));
    }

    return from(payloadChunks).pipe(
      mergeMap((chunk) => this.executePriceBookBulkUpdate(chunk)),
      toArray()
    );

  }

  getPriceBookBulkUpdateUploadSteps() {
    return of({
      "data": [{ "state_id": 1, "name": "Upload" },
          { "state_id": 2, "name": "Data Validation" },
          { "state_id": 3, "name": "Initiated" }],
      "status": 200
    })
  }

  exportCSV(body): Observable<string> {
    let request_url = 'api/pricebook/bulkupdate/export-summary';
    return this.http.post(request_url,body, { responseType: 'text' });
  }

  getPriceBookPaginatorData(paginatorObj): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/customer-subscription/info`;
    let request_body = {
      page: paginatorObj.pageIndex,
      items_per_page: paginatorObj.pageSize,
      trans_id: paginatorObj.transactionID,
      paginate_filter: paginatorObj.filterValue,
      pagination_sortby: paginatorObj.sortBy,
      pagination_sortorder: paginatorObj.sortOrder,
      customers: paginatorObj.customers,
      cloud_accounts: paginatorObj.cloudAccountNumbers
    }
    return this.http.post(request_url,request_body)
  }

  uploadPriceBookCSV(fileData ): Observable<any> {
    const formData = new FormData();
    formData.append('csv_file', fileData);
    formData.append('user_id',JSON.parse(sessionStorage.getItem('userInfo')).user_id)
    let request_url = 'api/pricebook/bulkupdate/upload-pricebook';
    return this.http.post(request_url,formData);
  }

  updatePriceBook(data): Observable<any> {
    let request_url = `api/pricebook/bulkupdate/update/temp-pricebook`;
    return this.http.put(request_url,data);
  }

  onPublishPricebook(userID, transID = null) {
    let request_url = `api/pricebook/bulkupdate/execute/bulk-assignment`;
    let request_body = {
      user_id : userID,
      trans_id: transID
    }
    this.http.post(request_url,request_body).subscribe(() => { },
    (error) => {
      console.error('Error:', error);
    });
  }

  downloadPriceBookConsolidatedReport(id, type): Observable<string> {
    let request_url;
    if (type === 'success') {
      request_url = `api/pricebook/bulkupdate/get-bulktransaction-lines?trans_id=${id}`;
    } else {
      request_url = `api/pricebook/bulkupdate/get-bulktransaction-lines?trans_id=${id}&is_error=true`;
    }
    return this.http.get(request_url, { responseType: 'text' });
  }

  getActivityMonitorRefreshStatus(trans_id) {
    let request_url = `api/pricebook/bulkupdate/activity-monitor?trans_id=${trans_id}`;
    return this.http.get(request_url)
  }

  getStagedSubscriptionList(paginatorObj,type) {
    let request_url = `api/pricebook/bulkupdate/progress-staging?user_id=${paginatorObj.userID}`;
    if (type === 'init') {
      return this.http.get(request_url);
    } else if (type === 'view'){
      let params = new HttpParams()
      .set('page',paginatorObj.pageIndex.toString())
      .set('items_per_page', paginatorObj.pageSize.toString())
      if (paginatorObj.filterValue && paginatorObj.filterValue.length > 0) {
        params = params.append('paginate_filter', paginatorObj.filterValue.toString());
      }
      if (paginatorObj.sortBy && paginatorObj.sortBy.length > 0) {
        params = params.append('pagination_sortby', paginatorObj.sortBy.toString());
      }
      if (paginatorObj.sortOrder && paginatorObj.sortOrder.length > 0) {
        params = params.append('pagination_sortorder', paginatorObj.sortOrder.toString());
      }
      return this.http.get(request_url, {params: params});
    }
  }

  unstagePriceBooks(data,type, transactionID) {
    let request_url = `api/pricebook/bulkupdate/progress-staging?user_id=${data.user_id}`;
    if (type === 'individual') {
      let params = new HttpParams()
      .set('id', data.id)
      if (transactionID) {
        params = params.append('trans_id',transactionID)
      }
      return this.http.delete(request_url,{params: params})
    } else if (type === 'unstage_all') {
      let params = new HttpParams()
      if (transactionID) {
        params = params.append('trans_id',transactionID)
      }
      return this.http.delete(request_url,{params: params})
    }
  }

  moveToStage(trans_id) {
   let request_url = `api/pricebook/bulkupdate/progress-staging`;
   let request_body = {
    user_id: JSON.parse(sessionStorage.getItem('userInfo')).user_id,
    trans_id: trans_id
   }
   return this.http.post(request_url,request_body)
  }

  cancelBulkPricebookUpload(transID) {
    let request_url = `api/pricebook/bulkupdate/progress-staging`;
    let request_body = {
      trans_id: transID
    }
    return this.http.put(request_url,request_body)
  }

  discardModifiedRecords(transactionID: number) {
    let request_url = `api/pricebook/bulkupdate/update/temp-pricebook?trans_id=${transactionID}`;
    return this.http.delete(request_url)
  }

  checkUnpublishedRecords(methodName, moduleName, userID) {
    let request_url = `api/pricebook/bulkupdate/check-pending/staged?method=${methodName}&module=${moduleName}&user_id=${userID}`;
    return this.http.get(request_url)
  }

  downloadPartnerOnboardingStepDownloadReport(file_id: number,state_id: number,retry_count: number, page_name: string): Observable<HttpResponse<Blob>> {
    let request_url = page_name === 'partner_onboarding' ? `api/master/step-download-report/${file_id}/${state_id}/${retry_count}` : `api/master/customer-step-report/${file_id}/${state_id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/csv',
    });

    return this.http.get<Blob>(request_url, {
      headers: headers,
      responseType: 'blob' as 'json',
      observe: 'response', // Include the full response in the Observable
    })
  }

  retryPartnerMigration(file_id, state_id, retry_count,state_name) {
    let request_url = 'api/master/retry-partnerOnboarding';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      file_id: file_id,
      state_id: state_id,
      retry_count: retry_count,
      state_name : state_name    
    }

    return this.http.post(
      request_url,
      request_body
    );
  }

  getUpdatedResumeStates(file_id) {
    let request_url = `api/master/partner-transaction/info/?file_id=${file_id}`;
    return this.http.get(request_url);
  }

  unreadNotificationCount: number;
  getNotifications(page: number, limit: number) {
    let request_url = `api/notifications/manage_user_alerts/?page=${page}&limit=${limit}`;
    return this.http.get(request_url).pipe(shareReplay(1), tap((res: any) => {const val = res.user_unread_count;
      this.unreadNotificationCount = val === 0 ? null : val; }));
  }

  updateNotification(payload) {
    let request_url = `api/notifications/manage_user_alerts/`;
    return this.http.put(
      request_url,
      payload
    );
  }

  getCustomerCreationSteps(): Observable<any> {
    let request_url = `api/master/get-customer-creation-states`; //API required
    return this.http.get(
      request_url
    );
  }

  customerCreationUpload(data: any) {
    let request_url = 'api/master/customer-sheet-migration';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: data.fileName || '',
      fileData: data.fileData || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  startCustomerCreationMigration(data: any, state_id: number, state_name: string) {
    let request_url = 'api/master/customer-bulk-upload';
    let request_body = {
      username: JSON.parse(sessionStorage.getItem('userInfo')).username,
      fileName: data.fileName,
      fileData: data.fileData,
      file_id: data.id,
      state: state_name
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  getCustomerCreationMigrationStatus(file_id: number, state_id: number) {
    let request_url = `api/master/customer-creation-state/${file_id}/${state_id}`;
     return this.http.get(
      request_url   
    );
  }

  initCustomerCreationDataValidate(file_id: number, doValid: boolean){
    let request_url = `api/master/validate/usermigration`;
    let request_body = {
      file_id: file_id,
      do_validation: doValid,
      useremail: JSON.parse(sessionStorage.getItem('userInfo')).email
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  getCustomerCreationHistory(data): Observable<any> {
    let request_url = `api/master/customer-creation/transaction?file_id=0&from_date=${data.from_date}&to_date=${data.to_date}`;
    return this.http.get(
      request_url
    );
  }

  consolidatedtCustomerCreationReportDownload(file_id: number) {
    let request_url = `api/master/get-customer-consolidated/report/${file_id}/`;
    return this.http.get(
      request_url, {responseType: 'blob' as 'json'}
    )
  }

  getCustomerCreationActivityMonitorRefreshStatus(file_id) {
    let request_url = `api/master/get-customer-consolidated/report/${file_id}/?refresh=1`;
    return this.http.get(request_url)
  }

  priceBookRecreationUpload(data: any) {
    let request_url = 'api/pricebook/bulkupdate/clone-pricebook/upload';
    let request_body = {
      filename: data.fileName || '',
      file: data.fileData || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  partnerPriceBookMappingUpload(data: any) {
    let request_url = 'api/pricebook/bulkupdate/provider-pb-assignment/upload';
    let request_body = {
      filename: data.fileName || '',
      file: data.fileData || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  priceBookRecreationExecute(transactionId: number) {
    let request_url = 'api/pricebook/bulkupdate/clone-pricebook/execute';
    let request_body = {
      transaction_id: transactionId || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  partnerPriceBookMappingExecute(transactionId: number) {
    let request_url = 'api/pricebook/bulkupdate/provider-pb-assignment/execute';
    let request_body = {
      transaction_id: transactionId || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  priceBookSkuAdjustmentsUpload(data: any) {
    let request_url = 'api/pricebook/bulkupdate/sku-pb-adjustment/upload';
    let request_body = {
      filename: data.fileName || '',
      file: data.fileData || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  priceBookSkuAdjustmentsExecute(transactionId: number) {
    let request_url = 'api/pricebook/bulkupdate/sku-pb-adjustment/execute';
    let request_body = {
      transaction_id: transactionId || ''
    }
    return this.http.post(
      request_url,
      request_body
    );
  }

  downloadPriceBookValidationReport(trans_id: number, uploadType: string): Observable<HttpResponse<Blob>> {
    let request_url = `api/pricebook/bulkupdate/${uploadType}/download?transaction_id=${trans_id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/csv',
    });
    return this.http.get<Blob>(request_url, {
      headers: headers,
      responseType: 'blob' as 'json',
      observe: 'response', // Include the full response in the Observable
    })
  }
}